import { HistoryService } from './history-slider-service';
import { ActivatedRoute } from '@angular/router';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';


import { DateUtils, FROM_FORMAT, TO_FORMAT } from '@elotech/angular-common';
import { delay } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Options } from 'ngx-slider-v2';

export const moment = require('moment');

@Component({
  selector: 'history-slider',
  templateUrl: './history-slider.component.html',
  styleUrls: ['./history-slider.component.css']
})
export class HistorySliderComponent implements OnInit {

  @Input() entity: string;

  @Input() idFieldName: string;

  @Output() onDataLoad: EventEmitter<any> = new EventEmitter();

  isLoading: boolean = false;

  filterForm: UntypedFormGroup;

  value: number = 0;

  historyNotFound: boolean;

  pageable: any = {page: 0, firstResult: 0, maxResult: 10};

  entityHistory: any;
  revisions: any;

  lastSubscription: Subscription = null;

  options: Options = {
    showTicksValues: false,
    showTicks: true,
    animate: false,
    autoHideLimitLabels: true,
    keyboardSupport: false,
    stepsArray: [{value: 0, legend: ''}]
  };

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _historyService: HistoryService,
    private _formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.filterForm = this._formBuilder.group({
      'dataBase': DateUtils.format(new Date(), TO_FORMAT, FROM_FORMAT)
    });

    this.filterForm.get('dataBase').valueChanges.subscribe(() => {
      if (this.filterForm.get('dataBase').valid && this.filterForm.get('dataBase').value) {
        this.pageable.page = 0;
        this.loadRevs('left');
      }
    });

    this.loadRevs('left');
  }

  onSlider(): void {
    this.loadData();
  }

  @HostListener('document:keydown', ['$event'])
  public handleKeyboardEvent(event: any) {
    if (!this.isLoading && event.target.id !== 'dataPagamento'
      && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      this.navigate(event.key === 'ArrowLeft' ? 'left' : 'right');
    }
  }

  navigate(side: 'left' | 'right') {
    if (this.isLoading || this.historyNotFound) {
      return;
    }

    if (side === 'left') {
      if (this.revisions.last && this._sliderInFirstPos()) {
        return;
      }
      if (this._sliderInFirstPos()) {
        this.pageable.page = this.pageable.page + 1;
        this.loadRevs(side);
      } else {
        this.value = this.revisions.content[this._getCurrentRevisionIndex() - 1][1];
        this.loadData();
      }
    } else {
      if (this.revisions.first && this._sliderInLastPos()) {
        return;
      }
      if (this._sliderInLastPos()) {
        this.pageable.page = this.pageable.page - 1;
        this.loadRevs(side);
      } else {
        this.value = this.revisions.content[this._getCurrentRevisionIndex() + 1][1];
        this.loadData();
      }
    }
  }

  loadRevs(side: 'left' | 'right') {
    this.isLoading = true;
    this._historyService.getRevisions(
      this._activatedRoute.snapshot.params['id'],
      this.filterForm.get('dataBase').value,
      this.pageable,
      this.entity,
      this.idFieldName
    ).subscribe(entity => {
      this.revisions = entity;
      if (entity.content && entity.content.length > 0) {
        this.historyNotFound = false;

        let stepsArray = entity.content.map(e => {
          return {'value': e[1], 'legend': moment(e[0], 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY HH:mm')};
        });

        if (side === 'left') {
          this.value = stepsArray.slice(-1)[0].value;
        } else {
          this.value = stepsArray[0].value;
        }

        if (stepsArray.length === 1) {
          stepsArray.push({'value': 0, 'legend': ''});
          this._disableSlider();
        } else {
          this._enableSlider();
        }
        this.options = Object.assign({}, this.options, {stepsArray: stepsArray});
        this.loadData();
      } else {
        this.historyNotFound = true;
        this.isLoading = false;
      }
    });
  }

  loadData() {
    this._clearChangedClass();

    if (this.lastSubscription && !this.lastSubscription.closed) {
      this.lastSubscription.unsubscribe();
    }

    this.isLoading = true;
    this.lastSubscription = this._historyService.getEntityHistory(
      this._activatedRoute.snapshot.params['id'],
      this.value, this.entity, this.idFieldName)
      .pipe(
        delay(100)
      )
      .subscribe(entity => {
        this.onDataLoad.emit(entity);
        this.entityHistory = entity;
        this.isLoading = false;
        this._clearChangedClass();
        setTimeout(() => this._addChangedClass(entity.changes), 99);
      });
  }

  private _enableSlider() {
    this.options = Object.assign({}, this.options, {disabled: false});
  }

  private _disableSlider() {
    this.options = Object.assign({}, this.options, {disabled: true});
  }

  private _addChangedClass(keys: Array<any>) {
    keys.forEach(k => document.querySelectorAll(`#${k}`).forEach(i => i.classList.add('changed')));
    keys.forEach(k => document.querySelectorAll(`#${k}_button, #${k}_row`).forEach(i => i.classList.add('warning')));
  }

  private _clearChangedClass() {
    document.querySelectorAll('.changed').forEach(i => i.classList.remove('changed'));
  }

  private _sliderInFirstPos(): boolean {
    return this._getCurrentRevisionIndex() === 0;
  }

  private _sliderInLastPos(): boolean {
    return this._getCurrentRevisionIndex() === this.revisions.content.length - 1;
  }

  private _getCurrentRevisionIndex(): number {
    const item = this.revisions.content.find(item => item[1] === this.value);
    return this.revisions.content.indexOf(item);
  }

}
